import { encodeAssetUrl } from '@/app/utils/stringUtils';

export function getThumbSrc(thumbnail) {
    if (!thumbnail) return null;
    if (typeof thumbnail === 'object' && thumbnail.identifier) {
        return encodeAssetUrl(`/dA/${thumbnail.identifier}`);
    }
    if (typeof thumbnail === 'string') return encodeAssetUrl(thumbnail);
    return null;
}
